import z from 'zod';

export const senderSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string().nullable(),
  email: z.string().email().nullable(),
  phoneNumber: z.string(),
  brandName: z.string().optional(),
});

export type Sender = z.infer<typeof senderSchema>;
